/**
 * Padding applied to the IconButton based on the size prop provided.
 */ export const iconButtonPadding = {
    small: 4,
    medium: 6
};
/**
 * Component overrides (i.e. global styles, default props) applied to the MUI
 * IconButton to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/icon-button/#css
 */ export const MuiIconButton = {
    defaultProps: {},
    styleOverrides: {
        root: ({ theme })=>({
                // This is common for all variants
                borderRadius: theme.shape.borderRadius
            }),
        sizeSmall: {
            padding: iconButtonPadding.small
        },
        sizeMedium: {
            padding: iconButtonPadding.medium
        }
    }
};

//# sourceMappingURL=icon-button-overrides.js.map